import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

function Loading(props) {
  return <CircularProgress {...props} />;
}

export default Loading;
